function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 1L6.91 3.09L9 5.18V1ZM1.27 0L0 1.27L4.73 6H0V12H4L9 17V10.27L13.25 14.53C12.58 15.04 11.83 15.46 11 15.7V17.77C12.38 17.45 13.63 16.82 14.68 15.96L16.73 18L18 16.73L9 7.73L1.27 0ZM16 9C16 9.94 15.8 10.82 15.46 11.64L16.97 13.15C17.62 11.91 18 10.5 18 9C18 4.72 15 1.14 11 0.23V2.29C13.89 3.15 16 5.83 16 9ZM13.5 9C13.5 7.23 12.5 5.71 11 4.97V7.18L13.45 9.63C13.5 9.43 13.5 9.21 13.5 9Z",
  fill: "currentColor"
});

function SvgMuted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuted);
export default __webpack_public_path__ + "static/media/muted.14494e01.svg";
export { ForwardRef as ReactComponent };